/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSignResultsDto
 */
export interface GetSignResultsDto {
    /**
     * 
     * @type {number}
     * @memberof GetSignResultsDto
     */
    signedCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSignResultsDto
     */
    errors?: Array<string>;
}

/**
 * Check if a given object implements the GetSignResultsDto interface.
 */
export function instanceOfGetSignResultsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetSignResultsDtoFromJSON(json: any): GetSignResultsDto {
    return GetSignResultsDtoFromJSONTyped(json, false);
}

export function GetSignResultsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSignResultsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signedCount': !exists(json, 'signedCount') ? undefined : json['signedCount'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}

export function GetSignResultsDtoToJSON(value?: GetSignResultsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signedCount': value.signedCount,
        'errors': value.errors,
    };
}

